module.exports = __webpack_public_path__ + "static/media/296.6303f625.svg";